/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  PageHeader,
  Radio,
  Row,
  Select,
  Space,
  Switch,
} from 'antd'
import isEmpty from 'lodash/isEmpty'
import client from 'apollo'
import {
  GET_CC_EMAIL,
  GET_CLIENTS_FROM_EMAIL,
  GET_PRE_DETAIL_FOR_INVOICE,
} from '../graphql/Queries'
import moment from 'moment'
import { orderBy, uniq } from 'lodash'
import states from 'utils/states.json'
import Loader from 'components/loaders/Loader'
import { AppContext } from 'AppContext'
import HTMLRenderer from 'react-html-renderer'
import { CREATE_INVOICE, UPDATE_INVOICE } from '../graphql/Mutations'
import openNotification from 'utils/Notification'
import ReactQuill from 'react-quill'
import words from 'utils/words'
import CustomMeta from 'components/CustomMeta'
import { GET_ALL_CLIENT } from 'modules/Users/graphql/Queries'
import { getName, canUserAdd, canUserSave } from 'utils/User'
import { useQuery } from '@apollo/react-hooks'
import { GET_ILTS_REPORT } from 'modules/Reports/graphql/Queries'
import MandateEmail from './mandateMail'
import DueInvoiceTable from './dueInvoiceTable'
import { CREATE_TRANSACTION_VIA_UPI } from 'modules/Verification/graphql/Mutations'
import { convertNumberToCommaSeparate } from 'utils/utilities'

const FormItem = Form.Item
const { Option } = Select
const { Panel } = Collapse
const formItemLayout = {
  labelCol: { xs: { span: 24 }, sm: { span: 24 } },
  wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
}

const resolvePlanAmcPercentage = (amcPercentageVal, exposure) => {
  if (amcPercentageVal === null || amcPercentageVal === undefined || amcPercentageVal === 0 || amcPercentageVal === '') {
    return null
  }
  try {
    let parsed = typeof amcPercentageVal === 'string' ? JSON.parse(amcPercentageVal) : amcPercentageVal
    if (Array.isArray(parsed)) {
      let amcPer = null
      parsed.forEach((item) => {
        if (item?.minExposure && item?.maxExposure) {
          if (exposure >= item?.minExposure && exposure < item?.maxExposure) {
            amcPer = parseFloat(item?.percentage)
          }
        } else if (item?.minExposure && !item?.maxExposure) {
          if (exposure >= item?.minExposure) {
            amcPer = parseFloat(item?.percentage)
          }
        } else if (!item?.minExposure && item?.maxExposure) {
          if (exposure < item?.maxExposure) {
            amcPer = parseFloat(item?.percentage)
          }
        }
      })
      return amcPer
    }
    if (!isNaN(parseFloat(parsed))) {
      return parseFloat(parsed)
    }
  } catch (e) {
    if (!isNaN(parseFloat(amcPercentageVal))) {
      return parseFloat(amcPercentageVal)
    }
  }
  return null
}

const InvoiceMaster = () => {
  const {
    state: {
      invoiceSetting,
      generalSetting,
      isMobile,
      currentUser,
      userPermissions,
      isClient,
    } = {},
  } = useContext(AppContext) || {}

  const canAdd = canUserAdd(userPermissions || currentUser, isClient)
  const canSave = canUserSave(userPermissions || currentUser, isClient)
  const canCreateInvoice = canAdd && canSave

  const [ValueSelectClientType, setValueSelectClientType] = useState('')
  const [openReactQuill, setOpenReactQuill] = useState(false)
  const [invoiceCreateData, setInvoiceCreateData] = useState()
  const [invoiceExplanation, setInvoiceExplanation] = useState(false)
  const [invoiceExplanationValue, setInvoiceExplanationValue] = useState()
  const [deductionValue, setDeductionValue] = useState()
  const [amcCalculateType, setAmcCalculateType] = useState()
  const [loading, setLoading] = useState(false)
  const [emailValue, setEmailValue] = useState(false)
  const [clientCodeByEmail, setClientCodeByEmail] = useState(false)
  const [preview, setPreview] = useState(false)
  const [emailForClient, setEmailForClient] = useState('')
  const [clientCodeFromEmail, setClientCodeFromEmail] = useState()
  const [clientDetail, setClientDetail] = useState('')
  const [clientDetailsGet, setClientDetailsGet] = useState()
  const [amcType, setAMCType] = useState()

  // details States
  const [writeClientName, setWriteClientName] = useState('')
  const [manualClientCode, setManualClientCode] = useState('')
  const [manualEmailChange, setManualEmailChange] = useState('')
  const [manualAddress, setManualAddress] = useState('')
  const [userLoadingClient, setUserLoading] = useState(true)
  let [usersData, setUsersData] = useState([])
  const [onFinishLoader, setOnFinishLoader] = useState(false)
  const [onInvoiceGenerate, setOnInvoiceGenerate] = useState(false)
  const [selectedState, setSelectedState] = useState()

  // calculation States
  const [discountPer, setDiscountPer] = useState(0)
  const [commissionPer, setCommissionPer] = useState(0)
  const [manualDiscountAmcInPer, setManualDiscountAmcInPer] = useState(0)
  const [amcAmountTotal, setAmcAmountTotal] = useState()
  const [amcDiscountAmount, setAmcDiscountAmount] = useState(0)
  const [amcCommissionAmount, setAmcCommissionAmount] = useState(0)
  const [totalGrossAmount, setTotalGrossAmount] = useState()
  const [cgstAmount, setCGST9InPer] = useState()
  const [sgstAmount, setSGST9InPer] = useState()
  const [igstAmount, setIGST18InPer] = useState()
  const [totalNetAmountWithGst, setTotalNetAmountWithGst] = useState()
  const [quantityInput, setQuantityInput] = useState(0)
  const [niftyLotInput, setNiftyLotInput] = useState(0)
  const [auaCalculation, setAUACalculation] = useState(0)
  const [niftySpotState, setNiftySpotState] = useState(0)
  const [endDateOnChange, setEndDateOnChange] = useState()
  const [startDateOnChange, setStartDateOnChange] = useState()
  const [totalDueDay, setTotalDueDay] = useState()
  const [addressValue, setAddressValue] = useState(false)
  const [amcDueDate, setAmcDueDate] = useState()
  const [dueDate, setDueDate] = useState()
  const [isAdditionalDiscount, setIsAdditionalDiscount] = useState(false)
  const [additionalDiscountAmount, setAdditionalDiscountAmount] = useState(0)

  const isMarathon = clientDetailsGet?.user?.plan?.name?.toLowerCase()?.includes('marathon')
  const [totalFinalAmount, setTotalFinalAmount] = useState(0)
  const [additionalDiscountPer, SetAdditionalDiscountPer] = useState(0)
  const [eMandateDiscount, setEMandateDisCount] = useState(0)
  const [eMandateDiscountAmount, setEMandateDisCountAmount] = useState(0)
  const [amcCycle, setAmcCycle] = useState('YEARLY')
  const [form] = Form.useForm()

  const handleAmcCycleChange = (cycle) => {
    setAmcCycle(cycle)

    const nextEndDate =
      cycle === 'YEARLY'
        ? generalSetting?.amc_1YearEndDate || generalSetting?.amcEndDate
        : generalSetting?.amc_6MonthEndDate || generalSetting?.amcEndDate

    if (nextEndDate) {
      setEndDateOnChange(nextEndDate)
      form.setFieldsValue({
        endDate: moment(nextEndDate),
      })
    }
  }

  const { data, loading: iltsLoading } = useQuery(GET_ILTS_REPORT, {
    variables: { where: { clientCode: 'str04', date: null, strategy: '1001' } },
    fetchPolicy: 'network-only',
  })

  let amcPerTotal

  const getClientCodeOptionLabel = (user) =>
    `${user.clientCode} - ${getName(user)}${user?.plan?.name
      ? ` - ${user.plan.name}`
      : ''
    }`

  useEffect(() => {
    if (amcType) {
      invoiceSetting?.amcDates.forEach((item) => {
        if (amcType.toLowerCase() === item?.amcType?.toLowerCase()) {
          setDueDate(moment(item?.amcFinalDueDate).format('YYYY-MM-DD'))
        }
      })
    }
  }, [amcType, invoiceSetting])

  useEffect(() => {
    const effectiveStartDate = startDateOnChange || clientDetailsGet?.startDate
    const effectiveEndDate = endDateOnChange || generalSetting.amcEndDate
    const shouldRecalculateDueDay = !!(startDateOnChange || endDateOnChange)

    if (shouldRecalculateDueDay && effectiveStartDate && effectiveEndDate) {
      setTotalDueDay(
        moment(effectiveEndDate).diff(moment(effectiveStartDate), 'days') + 1
      )
      return
    }

    if (clientDetailsGet?.dueDay) {
      setTotalDueDay(+clientDetailsGet?.dueDay)
      return
    }

    if (effectiveStartDate && effectiveEndDate) {
      setTotalDueDay(
        moment(effectiveEndDate).diff(moment(effectiveStartDate), 'days') + 1
      )
    }
  }, [clientDetailsGet, endDateOnChange, generalSetting, startDateOnChange])

  useEffect(() => {
    setCommissionPer(clientDetailsGet?.commissionInPer || 0)
  }, [clientDetailsGet])

  useEffect(() => {
    if (amcPerTotal >= 0) {
      let auaForCalc = auaCalculation
      if (isMarathon) {
        auaForCalc = Math.ceil((auaCalculation / 2) / 50000) * 50000
      } else {
        auaForCalc = Math.ceil(auaCalculation / 10000) * 10000
      }
      let calculatedAmount = auaForCalc *
        ((amcPerTotal - manualDiscountAmcInPer) / 100) *
        (totalDueDay / 365)

      setAmcAmountTotal(Math.round(calculatedAmount))
    }
  }, [amcPerTotal, manualDiscountAmcInPer, auaCalculation, totalDueDay, isMarathon])

  useEffect(() => {
    if (amcType) {
      if (amcType === 'NEW') {
        setAmcDueDate(
          startDateOnChange
            ? moment(startDateOnChange).format('DD-MMM-YYYY')
            : clientDetailsGet?.startDate
              ? moment(clientDetailsGet?.startDate).format('DD-MMM-YYYY')
              : moment().format('DD-MMM-YYYY')
        )
      } else if (amcType === 'RENEWAL') {
        setAmcDueDate(
          startDateOnChange
            ? moment(startDateOnChange)
              .add('days', invoiceSetting.amcDates[1].day)
              .format('DD-MMM-YYYY')
            : clientDetailsGet?.startDate
              ? moment(clientDetailsGet?.startDate)
                .add('days', invoiceSetting.amcDates[1].day)
                .format('DD-MMM-YYYY')
              : moment()
                .add('days', invoiceSetting.amcDates[1].day)
                .format('DD-MMM-YYYY')
        )
      }
    }
  }, [amcType, clientDetailsGet, startDateOnChange, invoiceSetting])

  useEffect(() => {
    setAmcDiscountAmount(amcAmountTotal * (discountPer / 100))
  }, [amcAmountTotal, discountPer])

  useEffect(() => {
    setAmcCommissionAmount(
      (amcAmountTotal - amcDiscountAmount - eMandateDiscountAmount) *
      (commissionPer / 100)
    )
  }, [amcAmountTotal, commissionPer, amcDiscountAmount, eMandateDiscountAmount])

  useEffect(() => {
    setTotalGrossAmount(
      amcAmountTotal -
      amcDiscountAmount -
      (eMandateDiscountAmount || 0) -
      amcCommissionAmount
    )
    // // }
  }, [
    amcAmountTotal,
    amcCommissionAmount,
    amcDiscountAmount,
    eMandateDiscountAmount,
  ])

  useEffect(() => {
    setQuantityInput(+niftyLotInput * generalSetting.niftyLotSize)
  }, [generalSetting.niftyLotSize, niftyLotInput])

  useEffect(() => {
    setNiftySpotState(
      Math.round(
        clientDetailsGet?.niftySpot
          ? clientDetailsGet?.niftySpot
          : data?.spIltsreport[0][0]?.NIFTY
      )
    )
  }, [clientDetailsGet, data])

  useEffect(() => {
    // if (clientDetailsGet?.isFamilyGroup) {
    //   setAUACalculation(clientDetailsGet?.aua)
    // } else {
    setAUACalculation(niftySpotState && niftySpotState * quantityInput)
    // }
  }, [clientDetailsGet, niftySpotState, quantityInput])

  useEffect(() => {
    setEMandateDisCountAmount(
      Math.round(
        (amcAmountTotal - amcDiscountAmount) * (eMandateDiscount / 100)
      )
    )
  }, [amcAmountTotal, amcDiscountAmount, eMandateDiscount])

  useEffect(() => {
    setCGST9InPer(Math.round(totalGrossAmount * (9 / 100)))
    setSGST9InPer(Math.round(totalGrossAmount * (9 / 100)))
    setIGST18InPer(Math.round(totalGrossAmount * (18 / 100)))
    if (selectedState === 4030 || clientDetailsGet?.state === 4030) {
      setTotalNetAmountWithGst(
        Math.round(totalGrossAmount + cgstAmount + sgstAmount)
      )
    } else {
      setTotalNetAmountWithGst(Math.round(totalGrossAmount + igstAmount))
    }
  }, [
    cgstAmount,
    clientDetailsGet,
    igstAmount,
    selectedState,
    sgstAmount,
    totalGrossAmount,
  ])

  useEffect(() => {
    client
      .query({
        query: GET_ALL_CLIENT,
        variables: {
          where: {},
          limit: 1000000,
        },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        res.data.getClientUsers.users.map((user) => {
          return usersData.push(user)
        })
        setUsersData(usersData)
        setUserLoading(false)
      })
      .catch((err) => console.log({ err }))
      .finally(() => setUserLoading(false))
  }, [usersData])

  useEffect(() => {
    if (selectedState === 4030 || clientDetailsGet?.state === 4030) {
      setAddressValue(true)
    } else if (selectedState !== 4030 || clientDetailsGet?.state !== 4030) {
      setAddressValue(false)
    }
  }, [clientDetailsGet, selectedState])

  useEffect(() => {
    if (additionalDiscountAmount) {
      setTotalFinalAmount(
        Math.round(totalNetAmountWithGst - additionalDiscountAmount)
      )
    } else {
      setTotalFinalAmount(totalNetAmountWithGst)
    }
  }, [totalNetAmountWithGst, additionalDiscountAmount])

  let amcPer
  let compareAmc
  let auaForAmcPerCalculate = auaCalculation
  if (isMarathon) {
    auaForAmcPerCalculate = Math.ceil((auaCalculation / 2) / 50000) * 50000
  } else {
    auaForAmcPerCalculate = Math.ceil(auaCalculation / 10000) * 10000
  }
  if (amcCalculateType === 'AUA' && amcType === 'NEW') {
    auaForAmcPerCalculate =
      (clientDetailsGet?.isFamilyGroup
        ? clientDetailsGet?.auaCalculation
        : +clientDetailsGet?.aua || 0) + auaCalculation
    if (isMarathon) {
      auaForAmcPerCalculate = Math.ceil((auaForAmcPerCalculate / 2) / 50000) * 50000
    } else {
      auaForAmcPerCalculate = Math.ceil(auaForAmcPerCalculate / 10000) * 10000
    }
  }

  const planAmcPercentage = resolvePlanAmcPercentage(clientDetailsGet?.user?.plan?.amcPercentage, auaForAmcPerCalculate)

  if (clientDetailsGet?.clientAmcPer) {
    amcPerTotal = clientDetailsGet?.clientAmcPer
  } else if (planAmcPercentage !== null && planAmcPercentage !== undefined) {
    amcPerTotal = planAmcPercentage
  } else {
    invoiceSetting?.amcPercentage?.forEach((item) => {
      if (item?.minExposure && item?.maxExposure) {
        if (
          auaForAmcPerCalculate >= item?.minExposure &&
          auaForAmcPerCalculate < item?.maxExposure
        ) {
          compareAmc = parseFloat(item?.percentage)
          if (!clientDetailsGet?.clientAmcPer) {
            amcPer = parseFloat(item?.percentage)
          }
        }
      } else if (item?.minExposure && !item?.maxExposure) {
        if (auaForAmcPerCalculate >= item?.minExposure) {
          compareAmc = parseFloat(item?.percentage)
          if (!clientDetailsGet?.clientAmcPer) {
            amcPer = parseFloat(item?.percentage)
          }
        }
      } else if (!item?.minExposure && item?.maxExposure) {
        if (auaForAmcPerCalculate < item?.maxExposure) {
          compareAmc = parseFloat(item?.percentage)
          if (!clientDetailsGet?.clientAmcPer) {
            amcPer = parseFloat(item?.percentage)
          }
        }
      }
    })
    if (clientDetailsGet?.isFamilyGroup) {
      amcPer = clientDetailsGet?.familyAmcPer
    }

    if (!clientDetailsGet?.clientAmcPer) {
      if (invoiceSetting?.selectAmcPercentage === 'high') {
        amcPerTotal = Math.max(amcPer, compareAmc)
      } else if (invoiceSetting?.selectAmcPercentage === 'low') {
        amcPerTotal = Math.min(amcPer, compareAmc)
      } else {
        amcPerTotal = compareAmc
      }
    }
  }
  const getClientCode = () => {
    if (!canCreateInvoice) {
      openNotification('error', 'You do not have permission to generate invoices.')
      return
    }
    setClientCodeByEmail(true)
    client
      .query({
        query: GET_CLIENTS_FROM_EMAIL,
        variables: { where: { email: emailForClient } },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        setEmailValue(true)
        setClientCodeFromEmail(res.data.getClientsFromEmail)
        setClientCodeByEmail(false)
      })
      .catch((err) => setLoading(false))
  }

  const submitClientCodeByClientCode = () => {
    if (!canCreateInvoice) {
      openNotification('error', 'You do not have permission to generate invoices.')
      return
    }
    setLoading(true)
    client
      .query({
        query: GET_PRE_DETAIL_FOR_INVOICE,
        variables: { where: { id: clientDetail } },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        const preDetail = res?.data?.getPreDetailForInvoice

        setClientDetailsGet(preDetail)

        if (preDetail) {
          form.setFieldsValue({
            address: preDetail?.address,
            clientCode: preDetail?.clientCode,
            clientName: preDetail?.clientName,
            dueDay: preDetail?.dueDay,
            emailId: preDetail?.emailId,
            endDate: preDetail?.endDate ? moment(preDetail.endDate) : undefined,
            niftySpot: preDetail?.niftySpot
              ? Math.round(preDetail.niftySpot)
              : Math.round(data?.spIltsreport[0][0]?.NIFTY),
            startDate: preDetail?.startDate
              ? moment(preDetail.startDate)
              : undefined,
            state: preDetail?.state,
            commissionInPer: preDetail?.commissionInPer || '',
            discountInPer: preDetail?.discountStatus,
          })

          handleAmcCycleChange(preDetail?.amcCycle || 'YEARLY')
          setDiscountPer(preDetail?.discountStatus)
        }

        setLoading(false)
      })
      .catch((err) => setLoading(false))
  }

  const numberToWords =
    isAdditionalDiscount && additionalDiscountAmount > 0
      ? words(Math.round(totalFinalAmount))
      : words(Math.round(totalNetAmountWithGst))

  let planNameForParticular = invoiceSetting?.billTypeParticular
  const planNameLower = clientDetailsGet?.user?.plan?.name?.toLowerCase() || ''
  const strategyCode = clientDetailsGet?.user?.plan?.strategyCode || ''

  if (planNameLower.includes('marathon')) {
    planNameForParticular = 'Marathon Plan'
  } else if (planNameLower.includes('finrakshak') || planNameLower.includes('fin rakshak')) {
    planNameForParticular = 'FinRakshak Plan'
  } else if (
    strategyCode === '1005' || 
    planNameLower.includes('relax') || 
    planNameLower.includes('comfort') || 
    planNameLower.includes('booster') || 
    planNameLower.includes('basic') || 
    planNameLower.includes('ilts') ||
    planNameLower.includes('index long term')
  ) {
    planNameForParticular = 'Index Long Term Strategy'
  }

  let displayAuaForCalc = auaCalculation;
  if (isMarathon) {
    displayAuaForCalc = Math.ceil((auaCalculation / 2) / 50000) * 50000;
  } else {
    displayAuaForCalc = Math.ceil(auaCalculation / 10000) * 10000;
  }

  const html = `
    <html>
  <head>
  <title>Invoice</title>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>
  </head>
  <style>
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
      color: #000;
    }
    </style>
  <body>
  <div style="display: flex;justify-content: space-between; padding:0 3% 0 5%;align-items:center">
    <div>
      <div style="line-height: 2; font-size: 20px"><span style="color: #ff0000">${invoiceSetting?.companyName.slice(
    0,
    3
  )}</span><span style="color: #000;">${invoiceSetting?.companyName.slice(
    3
  )}</span></div>
      <span style="color: #000;">${invoiceSetting?.address}</span>
    </div>
    <div>

    </div>
    <div>
      <img style="width:${isMobile ? '330px' : '140px'
    } ;height: 50px" src="https://fiapl-india.blr1.digitaloceanspaces.com/Finideas-black-png.png" alt=""/>
    </div>
  </div>
  <div style="padding: 0 5%">
    <div><span style="color: #000;">${invoiceSetting?.webEmail}</span>
      </div >
  <div style="display: flex;justify-content: space-between">
    <div>
    </div>
    <div>
      <div style="color: #000;"><span style="font-weight:700">Invoice No:</span>    ${invoiceSetting?.invoiceNumber
    }</div>
      <div style="color: #000;"><span style="font-weight:700">Invoice Date:</span>  ${startDateOnChange
      ? moment(startDateOnChange).format('DD-MMM-YYYY')
      : clientDetailsGet?.startDate
        ? moment(clientDetailsGet?.startDate).format('DD-MMM-YYYY')
        : moment().format('DD-MMM-YYYY')
    }</div>
      <div style="color: #000;"><span style="font-weight:700">Due Date:</span>      ${amcDueDate}</div>
    </div>
  </div>
  <div style="display: flex;justify-content: space-between">
    <div style="color: #000;">
      <div style:"line-height: normal"><span style="font-weight:700">To,</span></div>
      <div style:"line-height: normal">${writeClientName ? writeClientName : clientDetailsGet?.clientName
    }</div>
      <div style:"line-height: normal">${manualAddress ? manualAddress : clientDetailsGet?.address
    }</div>
    </div>
    <div>
    </div>
  </div>
  <div style="line-height: normal">&nbsp;</div>
  <div>
    <table style="width:100%">
    <thead>
      <tr>
        <td colspan = "4" style="text-align:center; font-size: 20px"><u><b>Proforma Service Invoice</b></u></td>
      </tr>
      </thead>
      <tr>
        <td style="text-align:center; font-size: 14px"><b>Particulars</b></td>
        <td style="text-align:end; width: 20% ; font-size: 14px"><b>Amount (Rs.)</b></td>
      </tr>
      <tr>
        <td>
          <p style="font-weight:700">&nbsp;${planNameForParticular}</p>
          <div style="display: flex;width:100%">
            <div>
              <div style:"line-height: normal;font-weight:700">&nbsp;<b>Period:</b></div>
              <div style:"line-height: normal;font-weight:700">&nbsp;<b>AUA:</b></div>
              <div style:"line-height: normal;font-weight:700">&nbsp;<b>AMC%:</b></div>
              ${manualDiscountAmcInPer > 0
      ? `<div style:"line-height: normal;font-weight:700">&nbsp;<b>Discount AMC%:</b></div>`
      : ''
    }
              ${amcType === 'NEW' && amcCalculateType !== 'AUA'
      ? `<div style:"line-height: normal;font-weight:700">&nbsp;<b>Nifty Index Value:</b></div>`
      : ''
    }
              <div style:"line-height: normal">&nbsp;<b>AMC:</b></div>
              ${discountPer > 0
      ? `<div style:"line-height: normal">&nbsp;<b>${'Discount:'}</b></div>`
      : ''
    }
              ${eMandateDiscountAmount > 0
      ? `<div style:"line-height: normal">&nbsp;<b>${'E-Mandate Discount:'}</b></div>`
      : ''
    }
               ${commissionPer > 0
      ? `<div style:"line-height: normal">&nbsp;<b>${'Commission:'}</b></div>`
      : ''
    }
              <div style:"line-height: normal">&nbsp;<b>Total:</b></div>
            </div>
            <div style="margin-left:20px">
              <div style:"line-height: normal" style="font-weight: 500;">
              <span style="font-weight: 500;">
              ${startDateOnChange
      ? moment(startDateOnChange).format('DD-MMM-YYYY')
      : clientDetailsGet?.startDate
        ? moment(clientDetailsGet?.startDate).format('DD-MMM-YYYY')
        : moment().format('DD-MMM-YYYY')
    }
              TO
              ${endDateOnChange
      ? moment(endDateOnChange).format('DD-MMM-YYYY')
      : clientDetailsGet?.endDate
        ? moment(clientDetailsGet?.endDate).format('DD-MMM-YYYY')
        : moment().format('DD-MMM-YYYY')
    }
              </span>
              </div>
              
              <div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
      isMarathon ? displayAuaForCalc : auaCalculation
    )}</span></div>
              <div style:"line-height: normal"><span style="font-weight: 500;">${amcPerTotal}%</span></div>
              ${manualDiscountAmcInPer > 0
      ? `<div style:"line-height: normal" > <span style="font-weight: 500;">${manualDiscountAmcInPer}%</span></div>`
      : ''
    }
              ${amcType === 'NEW' && amcCalculateType !== 'AUA'
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        niftySpotState
      )}</span></div>`
      : ''
    }

              ${manualDiscountAmcInPer > 0
      ? `
               <div style:"line-height: normal"><span style="font-weight: 500;">
               ${`${Math.round(isMarathon ? displayAuaForCalc : auaCalculation)} X (${amcPerTotal + '%'} - ${manualDiscountAmcInPer + '%'
      }) X ${Math.round(totalDueDay) + '/' + 365}`} = ${Math.round(
        amcAmountTotal
      )}
               </span></div>`
      : `<div style:"line-height: normal"><span style="font-weight: 500;">
               ${`${Math.round(isMarathon ? displayAuaForCalc : auaCalculation)} X (${amcPerTotal + '%'}) X ${Math.round(totalDueDay) + '/' + 365
      }`} = ${Math.round(amcAmountTotal)}
               </span></div>`
    }
              ${discountPer > 0
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${discountPer}%</span></div>`
      : ''
    }
              ${eMandateDiscountAmount > 0
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        eMandateDiscount
      )}%</span></div>`
      : ''
    }
               ${commissionPer > 0
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        commissionPer
      )}%</span></div>`
      : ''
    }
            </div>
          </div>
        </td>
        <td style="text-align:end; padding-right:5px">
        <div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
      amcAmountTotal
    )}</span></div>
          <div style:"line-height: normal">&nbsp;</div>
          <div style:"line-height: normal">&nbsp;</div>
            ${amcType === 'NEW' && amcCalculateType !== 'AUA'
      ? `<div style:"line-height: normal">&nbsp;</div>`
      : ''
    }
          <div style:"line-height: normal">&nbsp;</div>
          <div style:"line-height: normal">&nbsp;</div>
          <div style:"line-height: normal">&nbsp;</div>
          ${amcDiscountAmount > 0
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        amcDiscountAmount
      )}</span></div>`
      : ''
    }
          ${eMandateDiscountAmount > 0
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        eMandateDiscountAmount
      )}</span></div>`
      : ''
    }
          ${amcCommissionAmount > 0
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        amcCommissionAmount
      )}</span></div>`
      : ''
    }
          <div style:"line-height: normal; margin-top: 14px"><span style="font-weight: 500;">${Math.round(
      totalGrossAmount
    )}</span></div>
        </td>
      </tr>
      <tr>
        <td>
        ${!addressValue
      ? `<div style:"line-height: normal">&nbsp;<b>${'IGST @18%'}</b></div>`
      : ''
    }
      ${addressValue
      ? `<div style:"line-height: normal">&nbsp;<b>${'CGST @9%'}</b></div>`
      : ''
    }
      ${addressValue
      ? `<div style:"line-height: normal">&nbsp;<b>${'SGST @9%'}</b></div>`
      : ''
    }
          <br/>
          <br/>
          <div style:"line-height: normal">&nbsp;<b>Total GST</b></div>
        </td>
        <td style="text-align:end; padding-right:5px">
        ${!addressValue
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        igstAmount
      )}</span></div>`
      : ''
    }
    ${addressValue
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        cgstAmount
      )}</span></div>`
      : ''
    }
    ${addressValue
      ? `<div style:"line-height: normal"><span style="font-weight: 500;">${Math.round(
        sgstAmount
      )}</span></div>`
      : ''
    }
          <br/>
          <br/>
          <div style:"line-height: normal"><span style="font-weight: 500;">
    ${selectedState === 4030 || clientDetailsGet?.state === 4030
      ? Math.round(cgstAmount + sgstAmount)
      : Math.round(igstAmount)
    }
          </span></div>
        </td>
      </tr>
${isAdditionalDiscount &&
    `<tr>
<td>
${isAdditionalDiscount &&
      additionalDiscountAmount > 0 &&
      additionalDiscountPer > 0
      ? `<div style:"line-height: normal">&nbsp;<b>Discount ${additionalDiscountPer}%</b></div>`
      : isAdditionalDiscount &&
        additionalDiscountAmount > 0 &&
        additionalDiscountPer === 0
        ? `<div style:"line-height: normal">&nbsp;<b>Discount</b></div>`
        : ''
    }
</td>
<td style="text-align:end; padding-right:5px">
${isAdditionalDiscount && additionalDiscountAmount > 0
      ? `<div style:"line-height: normal"><span>${additionalDiscountAmount}</span></div>`
      : ''
    }</td>
</tr>`
    }
      <tr>
        <td>
          <div style:"line-height: normal">&nbsp;<b>Total</b></div>
        </td>
        <td style="text-align:end; padding-right:5px">
          <span style="font-weight:700">${Math.round(
      isAdditionalDiscount && additionalDiscountAmount > 0
        ? totalFinalAmount
        : totalNetAmountWithGst
    )}</span>
        </td>
      </tr>
      <tr>
        <td colspan = "4" style="text-transform: capitalize">&nbsp;<b>Rs.</b><span style="font-weight:700"> ${numberToWords}</span></td>
      </tr>
    </table>
    <br/>
    <h4 style="color: #000;">Terms & Conditions:</h4>
    <div style="color: #000;
                text-align: ${isMobile ? 'left' : 'left'};
                margin-left:${isMobile ? '0px' : '27px'}"
    >
    All Payments to be made in favor of <b>“
    ${invoiceSetting?.companyName}”</b></div>
    <div style="color: #000; text-align: ${isMobile ? 'left' : 'left'};
                margin-left:${isMobile ? '0px' : '27px'
    }">Bank detail for fund transfer</div>
     <div style="color: #000; text-align: ${isMobile ? 'left' : 'left'};
                margin-left:${isMobile ? '0px' : '27px'}">Account Name: ${invoiceSetting?.companyName
    }</div>
    <div style="color: #000; text-align: ${isMobile ? 'left' : 'left'};
                margin-left:${isMobile ? '0px' : '27px'}">Account No: ${invoiceSetting?.accountDetails
    }</div>
    <div style="color: #000; text-align: ${isMobile ? 'left' : 'left'};
                margin-left:${isMobile ? '0px' : '27px'};
                    margin-bottom: 10px;">Bank: ${invoiceSetting?.bankName
    } || Branch: ${invoiceSetting?.branchName} || IFSC Code:${invoiceSetting?.ifscCode
    }</div>
  <h4 style="color: #000;">PAN No: ${invoiceSetting?.panNumber.toUpperCase()} || GSTIN No.:${invoiceSetting?.gstinNumber
    }</h4>
  <div style="display: flex;justify-content: space-between;gap: 15px;">
    <div style="display: flex;justify-content: space-between">
    <div>
     <div style="font-weight:500;color: #000;">PAYMENT QR CODE</div>
    <div style="color: #000;">UPI ID:</div>
    <div style="color: #000;">${invoiceSetting?.upiId}</div>
    <img style="width:30px" src="data:image/png;base64,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" alt=""/>
    <img style="width:30px" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRC-iA1KoqvQI6NvTcu6b5YpRIyhOzJcMfBYQ&usqp=CAU" alt=""/>
    <img style="width:30px" src="data:image/png;base64,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" alt=""/>
    <img style="width:30px" src="data:image/png;base64,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" alt=""/>
  </div>
       <div><img src="https://quickchart.io/qr?text={{qrCodeUrl}}&size=110&margin=0" alt="QR Code" width="110" height="110" /></div>
    </div>
    <div>
      <h3 style="color: #000;">For ${invoiceSetting?.companyName}</h3>
      <br/>
      <br/>
      <h3 style="color: #000;">Authorized Signatory</h3>
    </div>
    </div>
    <div style="text-align:center;color: #000;">
      This is a Computer generated Invoice
    </div>
  </div>
  </div>
  </body>
  </html>
    `

  // {'
  // <div style="font-weight:500;color: #000;">PAYMENT QR CODE</div>
  // <div id='qrcode'></div>
  // '}

  const onFinish = (values) => {
    if (!canCreateInvoice) {
      openNotification('error', 'You do not have permission to generate invoices.')
      return
    }
    setOnFinishLoader(true)
    values = {
      ...values,
      dueDay: totalDueDay,
      clientCode: manualClientCode
        ? manualClientCode
        : clientDetailsGet?.clientCode,
      clientId: clientDetailsGet?.user?.id,
      emailId: manualEmailChange
        ? manualEmailChange
        : clientDetailsGet?.emailId,
      address: manualAddress ? manualAddress : clientDetailsGet?.address,
      state: values.state.toString(),
      discountInPer: +values.discountInPer,
      assetUnderAdvisory: Math.ceil(isMarathon ? (Math.ceil((auaCalculation / 2) / 50000) * 50000) : (Math.ceil(auaCalculation / 10000) * 10000)),
      amcInPer: amcPerTotal,
      clientType: ValueSelectClientType,
      pdfFileName: `${clientDetailsGet?.clientName}-${invoiceSetting?.invoiceNumber}`,
      invoiceNo: invoiceSetting?.invoiceNumber,
      amountInWord: numberToWords,
      niftyLot: +niftyLotInput,
      discountAmcInPer: manualDiscountAmcInPer
        ? +manualDiscountAmcInPer
        : parseInt(values.discountAmcInPer),
      commissionInPer: parseFloat(commissionPer)
        ? parseFloat(commissionPer)
        : 0,
      amcAmount: Math.round(amcAmountTotal),
      discountAmount: Math.round(amcDiscountAmount),
      commissionAmount: Math.round(amcCommissionAmount),
      grossTotalAmount: Math.round(totalGrossAmount),
      cgst9InPer: Math.round(cgstAmount),
      sgst9InPer: Math.round(sgstAmount),
      igst18InPer: Math.round(igstAmount),
      quantity: Math.round(quantityInput),
      totalNetAmount:
        isAdditionalDiscount && additionalDiscountAmount
          ? Math.round(totalFinalAmount)
          : Math.round(totalNetAmountWithGst),
      niftySpot: +niftySpotState,
      endDate: values.endDate.format('YYYY-MM-DD'),
      startDate: values.startDate.format('YYYY-MM-DD'),
      dueDate: dueDate,
      amcCalculateType,
      amcCycle,
      additionalDiscountAmount,
      eMandateDiscountPer: eMandateDiscount,
      eMandateDiscountAmount,
    }
    delete values.additionalDiscountPer
    delete values.isAdditionalDiscount
    delete values.eMandateDiscount
    delete values.type
    client
      .mutate({
        mutation: CREATE_TRANSACTION_VIA_UPI,
        variables: {
          data: {
            amount: Math.round(amcAmountTotal),
            amountWithGST: Math.round(totalNetAmountWithGst),
            clientId: clientDetailsGet?.user?.id,
            onboarding: false,
          },
        },
      })
      .then((res) => {
        client
          .mutate({
            mutation: CREATE_INVOICE,
            variables: {
              data: {
                ...values,
                invoiceNo: res?.data?.createTransactionViaUpi?.invoiceNo,
                transactionId:
                  res?.data?.createTransactionViaUpi?.transactionId,
                invoicePdfHtml: html
                  ?.replace(
                    '{{qrCodeUrl}}',
                    encodeURIComponent(res?.data?.createTransactionViaUpi?.url || '')
                  )
                  .replaceAll('false', ''),
              },
            },
          })

          .then((res) => {
            client
              .query({
                query: GET_CC_EMAIL,
                variables: {
                  clientCode: manualClientCode
                    ? manualClientCode
                    : clientDetailsGet?.clientCode,
                },
              })
              .then((resData) => {
                let ccMails = invoiceSetting?.otherMailId?.split(',') || []
                if (resData?.data?.getCCEmails?.HKeyEmail) {
                  ccMails.push(
                    ...resData?.data?.getCCEmails?.HKeyEmail?.split(',')
                  )
                }

                ccMails = uniq(ccMails)
                ccMails = ccMails.filter((item) => item !== '')

                setInvoiceCreateData({
                  ...res.data.createInvoice,
                  emailId: resData?.data?.getCCEmails?.email?.split(','),
                  ccMailIds: ccMails,
                })
                openNotification('success', 'Invoice Created Successfully')
                setOnFinishLoader(false)
                setOpenReactQuill(true)
              })
          })
          .catch((err) => openNotification('error', 'Something Went Wrong'))
          .finally(() => setOnFinishLoader(false))
      })
      .catch((err) => console.log({ err }))
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  const onSearch = (value) => {
    console.log('search:', value)
  }

  const handleInvoiceExplanation = () => {
    setOnInvoiceGenerate(true)
    client
      .mutate({
        mutation: UPDATE_INVOICE,
        variables: {
          where: { id: invoiceCreateData?.id },
          data: {
            amcExplanation: invoiceExplanationValue,
          },
        },
      })
      .then((res) => {
        openNotification('success', 'InvoiceGenerate SuccessFully')
        setOnInvoiceGenerate(false)
        window.location.reload()
      })
  }

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],

      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],

      ['clean'],
    ],

    keyboard: {
      bindings: {
        'list autofill': {
          prefix: /^\s*()$/,
        },
      },
    },
  }

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'color',
    'background',
    'image',
    'video',
    'align',
    'direction',
    'code-block',
    'formula',
  ]

  return loading || iltsLoading ? (
    <Loader />
  ) : (
    <div className='admin-content-wrapper generate-invoice'>
      <div
        style={{
          padding: isMobile ? '16px 10px' : '32px 40px',
          marginBottom: isMobile ? '5vh' : '1px',
        }}
      >
        {!openReactQuill && !invoiceExplanation && (
          <div>
            <div>
              <CustomMeta title={'Invoice'} description='' />

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '20px',
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? '18px' : '24px',
                    fontWeight: '600',
                    lineHeight: '26px',
                    letterSpacing: '-0.02em',
                    textAlign: 'left',
                    color: '#181C32',
                  }}
                >
                  Invoice Master
                </div>
              </div>
              {clientDetailsGet?.isFamilyGroup && (
                <Space
                  direction='vertical'
                  style={{
                    width: '100%',
                  }}
                >
                  <Alert message={clientDetailsGet?.message} type='info' />
                </Space>
              )}

              {!isEmpty(deductionValue) &&
                !isEmpty(amcType) &&
                !isEmpty(amcCalculateType) && (
                  <Space
                    direction='vertical'
                    style={{
                      width: '100%',
                    }}
                  >
                    <Alert
                      message={`Existing AUA is ${convertNumberToCommaSeparate(isMarathon ? (+clientDetailsGet?.aua || 0) / 2 : (+clientDetailsGet?.aua || 0)) ||
                        '0'
                        } ${clientDetailsGet?.isFamilyGroup &&
                        `, Family group total AUA is ${convertNumberToCommaSeparate(
                          isMarathon ? (+clientDetailsGet?.auaCalculation || 0) / 2 : (+clientDetailsGet?.auaCalculation || 0)
                        )}`
                        }, New AUA is ${convertNumberToCommaSeparate(
                          isMarathon ? auaCalculation / 2 : auaCalculation
                        )} , So Total AUA is ${convertNumberToCommaSeparate(
                          auaForAmcPerCalculate
                        )} , Final Amc is ${amcPerTotal}%.`}
                      type='info'
                    />
                  </Space>
                )}
              <Form
                form={form}
                {...formItemLayout}
                name='register'
                loading={loading}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
                scrollToFirstError
                className='client-form Invoice_Master'
                initialValues={{
                  address: clientDetailsGet?.address,
                  clientCode: clientDetailsGet?.clientCode,
                  clientName: clientDetailsGet?.clientName,
                  dueDay: clientDetailsGet?.dueDay
                    ? clientDetailsGet?.dueDay
                    : `${moment(generalSetting.amcEndDate).diff(
                      moment(clientDetailsGet?.startDate),
                      'days'
                    )}`,
                  emailId: clientDetailsGet?.emailId,
                  endDate: moment(generalSetting.amcEndDate),
                  niftySpot: clientDetailsGet?.niftySpot
                    ? Math.round(clientDetailsGet?.niftySpot)
                    : Math.round(data?.spIltsreport[0][0]?.NIFTY),
                  startDate: moment(clientDetailsGet?.startDate),
                  state: clientDetailsGet?.state,
                  commissionInPer: clientDetailsGet?.commissionInPer
                    ? clientDetailsGet?.commissionInPer
                    : '',
                  discountInPer: discountPer && discountPer,
                }}
                style={{
                  height: 'auto',
                }}
              >
                {!canCreateInvoice && (
                  <div style={{ margin: '0 20px 16px' }}>
                    <Alert
                      message='Read-Only Access: You do not have permission to generate or submit invoices.'
                      type='warning'
                      showIcon
                    />
                  </div>
                )}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    margin: '0 20px',
                    marginBottom: isMobile ? '20px' : '10px',
                  }}
                >
                  <>
                    {ValueSelectClientType !== 'MANUAL' && (
                      <FormItem name='type' label='Default Select'>
                        <Radio.Group
                          onChange={(e) => {
                            setValueSelectClientType(e.target.value)
                          }}
                          defaultValue={ValueSelectClientType}
                        >
                          <Radio
                            value={'MANUAL'}
                            disabled={ValueSelectClientType ? true : false}
                          >
                            Manual
                          </Radio>
                          <Radio
                            value={'CLIENT_CODE'}
                            disabled={ValueSelectClientType ? true : false}
                          >
                            Client Code
                          </Radio>
                          <Radio
                            value={'EMAIL_ID'}
                            disabled={ValueSelectClientType ? true : false}
                          >
                            E-mail
                          </Radio>
                        </Radio.Group>
                      </FormItem>
                    )}
                  </>
                  <Form.Item
                    wrapperCol={{
                      offset: 8,
                      span: 16,
                    }}
                  >
                    <Button
                      type='primary'
                      onClick={() => {
                        window.location.reload()
                      }}
                    >
                      Reset
                    </Button>
                  </Form.Item>
                </div>
                {isEmpty(clientDetailsGet) &&
                  ValueSelectClientType === 'CLIENT_CODE' && (
                    <>
                      <Form.Item
                        style={{
                          paddingTop: isMobile ? '16px' : '0px',
                        }}
                        label='Client Code'
                        name='Client Code'
                        rules={[
                          {
                            required: true,
                            message: 'Please Enter Client Code!',
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          showSearch
                          onChange={(e) => setClientDetail(e)}
                          filterOption={true}
                          optionFilterProp='title'
                          placeholder='Please select ClientCode'
                          disabled={clientDetailsGet?.clientCode ? true : false}
                        >
                          {!userLoadingClient &&
                            usersData.length &&
                            orderBy(usersData, 'id', 'desc').map(
                              (user) => {
                                return (
                                  user.clientCode && (
                                    <>
                                      <Option
                                        key={user.id}
                                        value={user.id}
                                        title={getClientCodeOptionLabel(user)}
                                      >
                                        {getClientCodeOptionLabel(user)}
                                      </Option>
                                    </>
                                  )
                                )
                              }
                            )}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        wrapperCol={{
                          offset: 8,
                          span: 16,
                        }}
                      >
                        <Button
                          type='primary'
                          onClick={submitClientCodeByClientCode}
                          disabled={!canCreateInvoice}
                        // loading={preData}
                        >
                          Submit
                        </Button>
                      </Form.Item>
                    </>
                  )}
                {isEmpty(clientDetailsGet)
                  ? ValueSelectClientType === 'EMAIL_ID' && (
                    <>
                      <FormItem
                        name='emailID'
                        label='Email Id'
                        rules={[
                          {
                            required: true,
                            message: 'Answer is require',
                          },
                        ]}
                      >
                        <Input
                          disabled={emailValue ? true : false}
                          onChange={(e) => {
                            setEmailForClient(e.target.value)
                          }}
                          placeholder='PLease Enter Email Id'
                        />
                      </FormItem>
                      {isEmpty(clientCodeFromEmail) && (
                        <Form.Item
                          wrapperCol={{
                            offset: 8,
                            span: 16,
                          }}
                        >
                          <Button
                            type='primary'
                            onClick={getClientCode}
                            loading={clientCodeByEmail}
                            disabled={!canCreateInvoice}
                          >
                            Submit
                          </Button>
                        </Form.Item>
                      )}
                      {!isEmpty(clientCodeFromEmail) && (
                        <>
                          <Form.Item
                            label='Select Client1'
                            name='Select Client1'
                            rules={[
                              {
                                required: true,
                                message: 'Please Select Client!',
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              getPopupContainer={(trigger) =>
                                trigger.parentElement
                              }
                              placeholder='Select a Client Code'
                              optionFilterProp='label'
                              onChange={(value) => {
                                setClientDetail(value)
                              }}
                              onSearch={onSearch}
                              filterOption={(input, option) =>
                                (option?.label ?? '')
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={clientCodeFromEmail}
                            />
                          </Form.Item>
                          <Form.Item
                            wrapperCol={{
                              offset: 8,
                              span: 16,
                            }}
                          >
                            <Button
                              type='primary'
                              onClick={submitClientCodeByClientCode}
                              disabled={!canCreateInvoice}
                            // loading={preData}
                            >
                              Submit
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </>
                  )
                  : ''}

                {ValueSelectClientType === 'MANUAL' ||
                  !isEmpty(clientDetailsGet) ? (
                  <>
                    <Collapse defaultActiveKey={['1']}>
                      <Panel header='Pending Invoice' key='1'>
                        <DueInvoiceTable
                          className='collapse_panel'
                          clientDetailsGet={clientDetailsGet}
                        />
                      </Panel>
                    </Collapse>
                    <div>
                      <Row>
                        <Col
                          className='gutter-row form_class'
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                        >
                          <FormItem
                            name='deduction'
                            label='Deduction'
                            rules={[
                              {
                                required: true,
                                message: 'Deduction is require',
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={(e) => {
                                setDeductionValue(e.target.value)
                                setEMandateDisCount(0)
                                setEMandateDisCountAmount(0)
                              }}
                              value={deductionValue}
                            >
                              <Radio value={'E_MANDATE'}>Emandate</Radio>
                              <Radio value={'NON_E_MANDATE'}>
                                Non-Emandate
                              </Radio>
                            </Radio.Group>
                          </FormItem>
                        </Col>
                        <Col
                          className='gutter-row form_class'
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                        >
                          <FormItem
                            name='amcType'
                            label='AMC Type'
                            rules={[
                              {
                                required: true,
                                message: 'AMC Type is require',
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={(e) => {
                                setAMCType(e.target.value)
                              }}
                              value={amcType}
                            >
                              <Radio value={'NEW'}>NEW</Radio>
                              <Radio value={'RENEWAL'}>Renewal</Radio>
                            </Radio.Group>
                          </FormItem>
                        </Col>
                        <Col
                          className='gutter-row form_class'
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                        >
                          <FormItem
                            label='Amc Calculate'
                            rules={[
                              {
                                required: true,
                                message: 'Amc Calculate Type is require',
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={(e) => {
                                setAmcCalculateType(e.target.value)
                                setNiftyLotInput(0)
                                setAUACalculation(0)
                                setIsAdditionalDiscount(false)
                                setAdditionalDiscountAmount(0)
                                SetAdditionalDiscountPer(0)
                              }}
                              value={amcCalculateType}
                            >
                              <Radio value={'NIFTY'}>Nifty Lot</Radio>
                              <Radio value={'AUA'}>AUA</Radio>
                            </Radio.Group>
                          </FormItem>
                        </Col>
                        <Col
                          className='gutter-row form_class'
                          xs={24}
                          sm={24}
                          md={6}
                          lg={6}
                          xl={6}
                        >
                          <FormItem label='AMC Cycle'>
                            <Radio.Group
                              onChange={(e) => {
                                handleAmcCycleChange(e.target.value)
                              }}
                              value={amcCycle}
                            >
                              <Radio value={'YEARLY'}>Yearly</Radio>
                              <Radio value={'HALF_YEARLY'}>6Month</Radio>
                            </Radio.Group>
                          </FormItem>
                        </Col>
                        {!isEmpty(deductionValue) &&
                          !isEmpty(amcType) &&
                          !isEmpty(amcCalculateType) && (
                            <>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Client Name'
                                  name='clientName'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter Client Name!',
                                    },
                                  ]}
                                >
                                  <Input
                                    onChange={(e) => {
                                      setWriteClientName(e.target.value)
                                    }}
                                    placeholder='Enter Client Name'
                                    disabled={
                                      clientDetailsGet?.clientCode
                                        ? true
                                        : false
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Client Code'
                                  name='clientCode'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter Client Code!',
                                    },
                                  ]}
                                >
                                  <Select
                                    allowClear
                                    getPopupContainer={(trigger) =>
                                      trigger.parentElement
                                    }
                                    showSearch
                                    onChange={(e) => {
                                      const selectedUser = usersData.find(
                                        (user) => user.id === e
                                      )
                                      setManualClientCode(
                                        selectedUser?.clientCode || ''
                                      )
                                    }}
                                    filterOption={true}
                                    optionFilterProp='title'
                                    placeholder='Please select ClientCode'
                                    disabled={
                                      clientDetailsGet?.clientCode
                                        ? true
                                        : false
                                    }
                                  >
                                    {!userLoadingClient &&
                                      usersData.length &&
                                      orderBy(usersData, 'id', 'desc').map(
                                        (user) => {
                                          return (
                                            user.clientCode && (
                                              <>
                                                <Option
                                                  key={user.id}
                                                  value={user.id}
                                                  title={getClientCodeOptionLabel(
                                                    user
                                                  )}
                                                >
                                                  {getClientCodeOptionLabel(
                                                    user
                                                  )}
                                                </Option>
                                              </>
                                            )
                                          )
                                        }
                                      )}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                                style={{
                                  padding: isMobile
                                    ? '0px !important'
                                    : '16px !important',
                                }}
                              >
                                <Form.Item
                                  label='Email'
                                  name='emailId'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter Email!',
                                    },
                                    {
                                      type: 'email',
                                      message: 'The input is not valid E-mail!',
                                    },
                                  ]}
                                >
                                  <Input
                                    onChange={(e) => {
                                      setManualEmailChange(e.target.value)
                                    }}
                                    placeholder='Enter Email'
                                    disabled={
                                      clientDetailsGet?.emailId ? true : false
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Address'
                                  name='address'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter Address!',
                                    },
                                  ]}
                                >
                                  <Input
                                    onChange={(e) => {
                                      setManualAddress(e.target.value)
                                    }}
                                    placeholder='Enter Address'
                                    disabled={
                                      clientDetailsGet?.address ? true : false
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <FormItem
                                  name='state'
                                  label='State'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'State is required !',
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    getPopupContainer={(trigger) =>
                                      trigger.parentElement
                                    }
                                    allowClear
                                    optionFilterProp='children'
                                    placeholder='State'
                                    className='display-field'
                                    onChange={(e) => setSelectedState(e)}
                                  // disabled={!editAccess ? false : true}
                                  >
                                    {orderBy(states, 'name').map((state) => (
                                      <Option
                                        key={state.id}
                                        value={state.id}
                                        disabled={
                                          clientDetailsGet?.state ? true : false
                                        }
                                      >
                                        {state.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </FormItem>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Discount%'
                                  name='discountInPer'
                                >
                                  <Input
                                    type='number'
                                    placeholder='Enter Discount%'
                                    onChange={(e) => {
                                      setDiscountPer(e.target.value)
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              {deductionValue === 'E_MANDATE' ? (
                                <Col
                                  className='gutter-row form_class'
                                  xs={24}
                                  sm={24}
                                  md={12}
                                  lg={12}
                                  xl={12}
                                >
                                  <Form.Item
                                    label='E-Mandate Discount%'
                                    name='eMandateDiscount'
                                  >
                                    <Input
                                      type='number'
                                      placeholder='Enter E-Mandate Discount'
                                      onChange={(e) =>
                                        setEMandateDisCount(+e.target.value)
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              ) : (
                                ''
                              )}

                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Commission%'
                                  name='commissionInPer'
                                >
                                  <Input
                                    type='number'
                                    placeholder='Enter Commission%'
                                    onChange={(e) => {
                                      setCommissionPer(e.target.value)
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Nifty Spot'
                                  name='niftySpot'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter Nifty Spot!',
                                    },
                                  ]}
                                >
                                  <Input
                                    type='number'
                                    placeholder='Enter Nifty Spot'
                                    disabled={amcCalculateType === 'AUA'}
                                    onChange={(e) =>
                                      setNiftySpotState(e.target.value)
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Nifty Lot'
                                  required={amcCalculateType !== 'AUA'}
                                  validateStatus={
                                    amcCalculateType !== 'AUA' && !niftyLotInput
                                      ? 'error'
                                      : ''
                                  }
                                  help={
                                    amcCalculateType !== 'AUA' && !niftyLotInput
                                      ? 'Please Enter Nifty Lot!'
                                      : ''
                                  }
                                >
                                  <Input
                                    type='number'
                                    value={niftyLotInput}
                                    placeholder='Enter Nifty Lot'
                                    disabled={amcCalculateType === 'AUA'}
                                    onChange={(e) => {
                                      setNiftyLotInput(e.target.value)
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item label='Quantity'>
                                  <Input
                                    type='number'
                                    placeholder='Enter Quantity'
                                    disabled
                                    value={quantityInput}
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Assets Under Advisory'
                                  required={amcCalculateType === 'AUA'}
                                  validateStatus={
                                    amcCalculateType === 'AUA' &&
                                      !auaCalculation
                                      ? 'error'
                                      : ''
                                  }
                                  help={
                                    amcCalculateType === 'AUA' &&
                                      !auaCalculation
                                      ? 'Assets Under Advisory is required'
                                      : ''
                                  }
                                >
                                  <Input
                                    value={Math.round(auaCalculation)}
                                    onChange={(e) =>
                                      setAUACalculation(+e.target.value)
                                    }
                                    type='number'
                                    placeholder='Enter Assets Under Advisory'
                                    disabled={amcCalculateType !== 'AUA'}
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item label='AMC%'>
                                  <Input
                                    value={amcPerTotal}
                                    type='number'
                                    placeholder='Enter AMC%'
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Discount AMC%'
                                  name='discountAmcInPer'
                                >
                                  <Input
                                    type='number'
                                    onChange={(e) => {
                                      setManualDiscountAmcInPer(e.target.value)
                                    }}
                                    placeholder='Enter Discount AMC%'
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Start Date'
                                  name='startDate'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter Start Date!',
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    onChange={(e) => {
                                      setStartDateOnChange(
                                        moment(e).format('YYYY-MM-DD')
                                      )
                                    }}
                                    getPopupContainer={(trigger) =>
                                      trigger.parentElement
                                    }
                                    style={{ width: '100%' }}
                                    placeholder='Start Date'
                                    format={'DD-MMM-YYYY'}
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='End Date'
                                  name='endDate'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter End Date!',
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    onChange={(e) => {
                                      setEndDateOnChange(
                                        moment(e).format('YYYY-MM-DD')
                                      )
                                    }}
                                    getPopupContainer={(trigger) =>
                                      trigger.parentElement
                                    }
                                    style={{ width: '100%' }}
                                    placeholder='End Date'
                                    format={'DD-MMM-YYYY'}
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item label='Due Day'>
                                  <Input
                                    value={totalDueDay}
                                    type='number'
                                    placeholder='Enter Due Day'
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item label='AMC Amount'>
                                  <Input
                                    type='number'
                                    placeholder='Enter AMC Amount'
                                    value={amcAmountTotal}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item label='Discount Amount'>
                                  <Input
                                    type='number'
                                    placeholder='Enter Discount Amount'
                                    value={Math.round(amcDiscountAmount) || 0}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item label='Commission Amount'>
                                  <Input
                                    type='number'
                                    placeholder='Enter Commission Amount'
                                    value={Math.round(amcCommissionAmount) || 0}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Gross Total Amount'
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'Please Enter Gross Total Amount!',
                                    },
                                  ]}
                                >
                                  <Input
                                    type='number'
                                    placeholder='Enter Gross Total Amount'
                                    value={Math.round(totalGrossAmount) || 0}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>

                              {selectedState === 4030 ||
                                clientDetailsGet?.state === 4030 ? (
                                <>
                                  <Col
                                    className='gutter-row form_class'
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                  >
                                    <Form.Item
                                      label='CGST 9%'
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please Enter CGST 9%!',
                                        },
                                      ]}
                                    >
                                      <Input
                                        type='number'
                                        placeholder='Enter CGST 9%'
                                        value={Math.round(cgstAmount) || 0}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col
                                    className='gutter-row form_class'
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                  >
                                    <Form.Item
                                      label='SGST 9%'
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please Enter SGST 9%!',
                                        },
                                      ]}
                                    >
                                      <Input
                                        type='number'
                                        placeholder='Enter SGST 9%'
                                        value={Math.round(sgstAmount) || 0}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                </>
                              ) : (
                                <Col
                                  className='gutter-row form_class'
                                  xs={24}
                                  sm={24}
                                  md={12}
                                  lg={12}
                                  xl={12}
                                >
                                  <Form.Item
                                    label='IGST 18%'
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Please Enter IGST 18%!',
                                      },
                                    ]}
                                  >
                                    <Input
                                      type='number'
                                      placeholder='Enter IGST 18%'
                                      value={Math.round(igstAmount) || 0}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col>
                              )}

                              {deductionValue === 'E_MANDATE' ? (
                                <Col
                                  className='gutter-row form_class'
                                  xs={24}
                                  sm={24}
                                  md={12}
                                  lg={12}
                                  xl={12}
                                >
                                  <Form.Item label='E-Mandate Discount Amount'>
                                    <Input
                                      disabled
                                      value={eMandateDiscountAmount}
                                    />
                                  </Form.Item>
                                </Col>
                              ) : (
                                ''
                              )}

                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  label='Total Net Amount'
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please Enter Total Net Amount!',
                                    },
                                  ]}
                                >
                                  <Input
                                    type='number'
                                    placeholder='Enter Total Net Amount'
                                    value={
                                      Math.round(
                                        isAdditionalDiscount &&
                                          additionalDiscountAmount > 0
                                          ? totalFinalAmount
                                          : totalNetAmountWithGst
                                      ) || 0
                                    }
                                    disabled
                                  />
                                </Form.Item>
                              </Col>

                              <Col
                                className='gutter-row form_class'
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Form.Item
                                  name='isAdditionalDiscount'
                                  label='Additional Discount'
                                >
                                  <Switch
                                    defaultChecked={isAdditionalDiscount}
                                    onClick={() => {
                                      setAdditionalDiscountAmount(0)
                                      SetAdditionalDiscountPer(0)
                                      setIsAdditionalDiscount(
                                        !isAdditionalDiscount
                                      )
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              {isAdditionalDiscount ? (
                                <>
                                  <Col
                                    className='gutter-row'
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                  >
                                    <Form.Item
                                      label='Additional Discount %'
                                      name='additionalDiscountPer'
                                    >
                                      <Input
                                        onChange={(e) =>
                                          SetAdditionalDiscountPer(
                                            +e.target.value
                                          )
                                        }
                                        autoComplete='off'
                                        style={{ width: '100%' }}
                                        type='number'
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col
                                    className='gutter-row'
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                  >
                                    <Form.Item
                                      validateStatus={
                                        isAdditionalDiscount &&
                                          !additionalDiscountAmount
                                          ? 'error'
                                          : ''
                                      }
                                      help={
                                        isAdditionalDiscount === 'AUA' &&
                                          !additionalDiscountAmount
                                          ? 'Additional Discount Amount is required'
                                          : ''
                                      }
                                      label='Additional Discount Amount'
                                    >
                                      <Input
                                        style={{ width: '100%' }}
                                        value={additionalDiscountAmount}
                                        onChange={(e) =>
                                          setAdditionalDiscountAmount(
                                            +e.target.value
                                          )
                                        }
                                        type='number'
                                      />
                                    </Form.Item>
                                  </Col>
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                      </Row>
                    </div>
                    {!isEmpty(deductionValue) &&
                      !isEmpty(amcType) &&
                      !isEmpty(amcCalculateType) && (
                        <div style={{ display: 'flex' }}>
                          <Form.Item
                            wrapperCol={{
                              offset: 8,
                              span: 16,
                            }}
                          >
                            <Button
                              type='primary'
                              onClick={() => {
                                setPreview(true)
                              }}
                              disabled={
                                (niftyLotInput > 0 &&
                                  amcCalculateType === 'NIFTY') ||
                                  (amcCalculateType === 'AUA' &&
                                    auaCalculation > 0)
                                  ? false
                                  : true
                              }
                            >
                              Preview
                            </Button>
                          </Form.Item>

                          {!canCreateInvoice && (
                            <div style={{ marginBottom: 16, width: '100%' }}>
                              <Alert
                                message='Read-Only Access: You do not have permission to create or submit invoices.'
                                type='warning'
                                showIcon
                              />
                            </div>
                          )}
                          <Form.Item
                            wrapperCol={{
                              offset: 8,
                              span: 16,
                            }}
                          >
                            <Button
                              type='primary'
                              htmlType='submit'
                              loading={onFinishLoader}
                              disabled={!canCreateInvoice}
                            >
                              Save
                            </Button>
                          </Form.Item>
                        </div>
                      )}
                  </>
                ) : (
                  ''
                )}
              </Form>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '20px 0',
              }}
            >
              <div
                style={{
                  width: isMobile ? '100%' : '70%',
                }}
              >
                {preview && (
                  <HTMLRenderer
                    html={
                      html.includes('false')
                        ? html?.replaceAll('false', '')
                        : html
                    }
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {openReactQuill && (
          <MandateEmail
            setOpenReactQuill={setOpenReactQuill}
            invoiceCreateData={invoiceCreateData}
            setInvoiceExplanation={setInvoiceExplanation}
            setInvoiceExplanationValue={setInvoiceExplanationValue}
            isSkip={true}
          />
        )}
        {invoiceExplanation && (
          <>
            <PageHeader className='box' title='Invoice Explanation' />
            <ReactQuill
              theme='snow'
              value={invoiceExplanationValue}
              onChange={(value) => {
                setInvoiceExplanationValue(value)
              }}
              modules={modules}
              formats={formats}
            />
            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
            >
              <Button
                type='primary'
                onClick={handleInvoiceExplanation}
                style={{ marginTop: '20px' }}
                loading={onInvoiceGenerate}
              >
                Save Invoice
              </Button>
            </Form.Item>
          </>
        )}
      </div>
    </div>
  )
}

export default InvoiceMaster
